import { render, staticRenderFns } from "./VideoFieldtype.vue?vue&type=template&id=349a0218&"
import script from "./VideoFieldtype.vue?vue&type=script&lang=js&"
export * from "./VideoFieldtype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports